// @ts-nocheck
import { ReactNode } from 'react'
import {
  Cipher,
  DetailCard,
  DetailText,
  IconDetailContainer,
  TextDetailContainer,
  ValueContainer,
  ValueText,
} from './styles'

interface SmallCardProps {
  icon?: ReactNode
  value?: number | string
  title?: string
  cipher?: string
}

export function SmallCard({ icon, value, title, cipher }: SmallCardProps) {
  return (
    <DetailCard>
      <IconDetailContainer>{icon}</IconDetailContainer>
      <TextDetailContainer>
        <DetailText>{title}</DetailText>
        <ValueContainer>
          <Cipher>{cipher}</Cipher>
          <ValueText>{value}</ValueText>
        </ValueContainer>
      </TextDetailContainer>
    </DetailCard>
  )
}
